export var KafkaKeyHandling;
(function (KafkaKeyHandling) {
    KafkaKeyHandling["KAFKA_KEY_HANDLING_IGNORE"] = "ignore";
    KafkaKeyHandling["KAFKA_KEY_HANDLING_STORE"] = "store";
})(KafkaKeyHandling || (KafkaKeyHandling = {}));
